module.exports = __webpack_public_path__ + "static/img/advModel1.9ea6753c.png";